import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  employeeLogin: JSON.parse(localStorage.getItem("employeeLogin")) || false,
  organisationLogin:
    JSON.parse(localStorage.getItem("organisationLogin")) || false,
  adminLogin: JSON.parse(localStorage.getItem("adminLogin")) || false,
  user: JSON.parse(localStorage.getItem("user")) || null,
  authToken: localStorage.getItem("authToken") || null,
  selectedGroupMember:
    JSON.parse(localStorage.getItem("selectedGroupMember")) || null,
  sessionExpired: false,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    loginAsEmployee(state, action) {
      state.employeeLogin = true;
      state.organisationLogin = false;
      state.adminLogin = false;
      localStorage.setItem("employeeLogin", true);
      localStorage.removeItem("organisationLogin");
      localStorage.removeItem("adminLogin");
      state.user = action.payload.user;
      state.authToken = action.payload.token;
      localStorage.setItem("user", JSON.stringify(action.payload.user));
      localStorage.setItem("authToken", action.payload.token);
    },
    loginAsOrganisation(state, action) {
      state.organisationLogin = true;
      state.employeeLogin = false;
      state.adminLogin = false;
      localStorage.setItem("organisationLogin", true);
      localStorage.removeItem("employeeLogin");
      localStorage.removeItem("adminLogin");

      state.user = action.payload.user;
      state.authToken = action.payload.token;

      localStorage.setItem("user", JSON.stringify(action.payload.user));
      localStorage.setItem("authToken", action.payload.token);
    },
    loginAsAdmin(state) {
      state.adminLogin = true;
      state.employeeLogin = false;
      state.organisationLogin = false;
      localStorage.setItem("adminLogin", true);
      localStorage.removeItem("employeeLogin");
      localStorage.removeItem("organisationLogin");
    },
    logout(state) {
      state.employeeLogin = false;
      state.organisationLogin = false;
      state.adminLogin = false;
      state.user = null;
      state.authToken = null;
      state.selectedGroupMember = null;
      localStorage.removeItem("employeeLogin");
      localStorage.removeItem("organisationLogin");
      localStorage.removeItem("adminLogin");
      localStorage.removeItem("user");
      localStorage.removeItem("authToken");
      localStorage.removeItem("orgId");
      localStorage.removeItem("selectedGroup");
      localStorage.removeItem("selectedGroupMember");
      localStorage.removeItem("selectedMemberDashboardData");
    },
    updateUserOrgMode(state, action) {
      if (state.user) {
        state.user.orgModeLocked = true;
        // Check if payload is an object (new format) or just string (fallback)
        const payload = action.payload;
        if (typeof payload === "object" && payload !== null) {
          state.user.orgStructureMode = payload.orgStructureMode;
          state.user.reportingYearType = payload.reportingYearType;
        } else {
          state.user.orgStructureMode = payload;
        }
        localStorage.setItem("user", JSON.stringify(state.user));
      }
    },
    updateUserCompletionStatus(state, action) {
      if (state.user) {
        state.user.isCompleted = action.payload;
        localStorage.setItem("user", JSON.stringify(state.user));
      }
    },
    updateOrganizationName(state, action) {
      if (state.user) {
        state.user.organizationName = action.payload;
        localStorage.setItem("user", JSON.stringify(state.user));
      }
    },
    completeFirstLogin(state) {
      if (state.user) {
        state.user.isFirstLogin = false;
        delete state.user.tempPassword;
        localStorage.setItem("user", JSON.stringify(state.user));
      }
    },
    setSelectedGroupMember(state, action) {
      state.selectedGroupMember = action.payload;
      if (action.payload) {
        localStorage.setItem(
          "selectedGroupMember",
          JSON.stringify(action.payload),
        );
      } else {
        localStorage.removeItem("selectedGroupMember");
        localStorage.removeItem("selectedMemberDashboardData");
      }
    },
    setSessionExpired(state, action) {
      state.sessionExpired = action.payload;
    },
  },
});

export const {
  loginAsEmployee,
  loginAsOrganisation,
  loginAsAdmin,
  logout,
  updateUserOrgMode,
  updateUserCompletionStatus,
  updateOrganizationName,
  completeFirstLogin,
  setSelectedGroupMember,
  setSessionExpired,
} = authSlice.actions;
export default authSlice.reducer;
